module.exports = __webpack_public_path__ + "static/media/svrworld.d502d34d.ico";